export const getQueryParams = location => {
  const url = new URL(location)
  const queryParams = Object.fromEntries(url.searchParams)
  return Object.keys(queryParams).length ? queryParams : null
}
